import React from "react";
import CarModelItem from "./CardList";

interface AccordionProps {
  contents: string[];
  title_contents: string[];
}

export const Accordion: React.FC<AccordionProps> = ({
  contents = [],
  title_contents = [],
}) => {
  if (!contents?.length || !title_contents?.length) {
    return null;
  }

  return (
    <section className="flex flex-col px-6 pt-4 pb-8 text-xs font-bold bg-white text-zinc-500 max-md:px-5">
      {contents.map((content, index) => {
        if (!title_contents[index]) return null;

        return (
          <React.Fragment key={index}>
            <CarModelItem
              name={title_contents[index] || ""}
              description={content || ""}
            />
            {index < contents.length - 1 && (
              <div className="shrink-0 mt-2 h-0.5 bg-zinc-300 max-md:max-w-full" />
            )}
          </React.Fragment>
        );
      })}
    </section>
  );
};

export default Accordion;
